import { IInboxMessage } from "../message";

import { IInboxMessageSubscriber } from "./connection";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const getIframeOrigin = (url: string) => new URL(url).origin;

export const createSubscriberNotifier =
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  (subscribers: Set<IInboxMessageSubscriber>) => (message: IInboxMessage, connectionId: string) => {
    subscribers.forEach(subscriber => {
      subscriber(message, connectionId);
    });
  };
